import { FieldError, FieldErrors, FieldValues } from "react-hook-form";

export const getFormError = (errors: FieldErrors<FieldValues>, accessor: string): string => {
    if (!errors?.[accessor]) return "";
    const fieldError: FieldError = errors[accessor] as FieldError;
    if (!fieldError) return "";
    return fieldError.message ?? "";
};
